module.exports = __webpack_public_path__ + "img/catalog (17).2fbba4f8.jpg";